import type { CvLanguage, LanguageLevel, SkillLevel } from '@/types/cv';

type LabelKey =
  | 'experience'
  | 'education'
  | 'skills'
  | 'languages'
  | 'projects'
  | 'certifications'
  | 'summary'
  | 'contact'
  | 'achievements'
  | 'present';

const labels: Record<CvLanguage, Record<LabelKey, string>> = {
  pl: {
    experience: 'Doświadczenie zawodowe',
    education: 'Edukacja',
    skills: 'Umiejętności',
    languages: 'Języki',
    projects: 'Projekty',
    certifications: 'Certyfikaty',
    summary: 'O mnie',
    contact: 'Kontakt',
    achievements: 'Osiągnięcia',
    present: 'obecnie',
  },
  en: {
    experience: 'Experience',
    education: 'Education',
    skills: 'Skills',
    languages: 'Languages',
    projects: 'Projects',
    certifications: 'Certifications',
    summary: 'About me',
    contact: 'Contact',
    achievements: 'Achievements',
    present: 'present',
  },
  de: {
    experience: 'Berufserfahrung',
    education: 'Ausbildung',
    skills: 'Fähigkeiten',
    languages: 'Sprachen',
    projects: 'Projekte',
    certifications: 'Zertifikate',
    summary: 'Über mich',
    contact: 'Kontakt',
    achievements: 'Leistungen',
    present: 'aktuell',
  },
};

export function cvLabel(language: CvLanguage, key: LabelKey): string {
  return labels[language]?.[key] ?? labels.pl[key];
}

const skillLevelLabels: Record<CvLanguage, Record<SkillLevel, string>> = {
  pl: {
    beginner: 'Początkujący',
    intermediate: 'Średnio zaawansowany',
    advanced: 'Zaawansowany',
    expert: 'Ekspert',
  },
  en: {
    beginner: 'Beginner',
    intermediate: 'Intermediate',
    advanced: 'Advanced',
    expert: 'Expert',
  },
  de: {
    beginner: 'Anfänger',
    intermediate: 'Mittelstufe',
    advanced: 'Fortgeschritten',
    expert: 'Experte',
  },
};

export function skillLevelLabel(language: CvLanguage, level: SkillLevel): string {
  return skillLevelLabels[language]?.[level] ?? level;
}

const languageLevelLabels: Record<CvLanguage, Record<LanguageLevel, string>> = {
  pl: {
    A1: 'A1',
    A2: 'A2',
    B1: 'B1',
    B2: 'B2',
    C1: 'C1',
    C2: 'C2',
    native: 'ojczysty',
  },
  en: {
    A1: 'A1',
    A2: 'A2',
    B1: 'B1',
    B2: 'B2',
    C1: 'C1',
    C2: 'C2',
    native: 'native',
  },
  de: {
    A1: 'A1',
    A2: 'A2',
    B1: 'B1',
    B2: 'B2',
    C1: 'C1',
    C2: 'C2',
    native: 'Muttersprache',
  },
};

export function languageLevelLabel(language: CvLanguage, level: LanguageLevel): string {
  return languageLevelLabels[language]?.[level] ?? level;
}
